module.exports = __webpack_public_path__ + "e7.no2.6afac040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e7.no2.jpg
// module id = 6Auv
// module chunks = 0